// @flow
import React from 'react';
import { Trans, Plural } from '@lingui/macro';

import { PRODUCT_NAME } from './enums';

export const LOGIN = <Trans>Login</Trans>;
export const LOGOUT = <Trans>Logout</Trans>;
export const PLEASE_ENTER_YOUR_MOBILE_NUMBER = (
  <Trans>Please enter your mobile number</Trans>
);
export const MOBILE_NUMBER = <Trans>Mobile number</Trans>;
export const WHATSAPP_NUMBER = <Trans>WhatsApp number</Trans>;
export const PROCEED = <Trans>Proceed</Trans>;
export const SEND_OTP = <Trans>Send OTP</Trans>;
export const FIND_MY_OUTLET = <Trans>Find my Outlet</Trans>;
export const UPDATE = <Trans>Update</Trans>;
export const UPDATE_NOW = <Trans>Update now</Trans>;
export const DO_YOU_HAVE_AN_ACCOUNT = (
  <Trans>Do you not have an account?</Trans>
);
export const SIGN_UP = <Trans>Sign Up</Trans>;
export const ENTER_YOUR_DETAILS_TO_REGISTER = (
  <Trans>Enter your details to register</Trans>
);

export const HOME = <Trans>Home</Trans>;
export const ORDERS = <Trans>Orders</Trans>;
export const REWARDS = <Trans>Rewards</Trans>;
export const ASSOCIATE_BRANDS = <Trans>Associate brands</Trans>;
export const YOUR_NAME = <Trans>Your name</Trans>;
export const POSTAL_CODE = <Trans>Postal Code</Trans>;
export const REMOVE = <Trans>Remove</Trans>;
export const LEDGER = <Trans>Ledger</Trans>;

export const SHOP_NAME = <Trans>Shop name</Trans>;
export const USER_NAME = <Trans>User name</Trans>;
export const SHOP_NAME_ALIAS = {
  [PRODUCT_NAME.BIDCO]: SHOP_NAME,
  [PRODUCT_NAME.BUYGRO]: SHOP_NAME,
  [PRODUCT_NAME.DISTIMAN]: SHOP_NAME,
  [PRODUCT_NAME.STONESLANE]: SHOP_NAME,
  [PRODUCT_NAME.GENIEE]: SHOP_NAME,
  [PRODUCT_NAME.DIGITALSAATHI]: USER_NAME,
};
export const OPENING_TIME = <Trans>Opening time</Trans>;
export const CLOSING_TIME = <Trans>Closing time</Trans>;
export const SHOP_ADDRESS = <Trans>Shop address</Trans>;
export const USER_ADDRESS = <Trans>User address</Trans>;
export const SHOP_ADDRESS_ALIAS = {
  [PRODUCT_NAME.BIDCO]: SHOP_ADDRESS,
  [PRODUCT_NAME.BUYGRO]: SHOP_ADDRESS,
  [PRODUCT_NAME.DISTIMAN]: SHOP_ADDRESS,
  [PRODUCT_NAME.STONESLANE]: SHOP_ADDRESS,
  [PRODUCT_NAME.GENIEE]: SHOP_ADDRESS,
  [PRODUCT_NAME.DIGITALSAATHI]: USER_ADDRESS,
};
export const LANDMARK = <Trans>Landmark</Trans>;
export const CITY = <Trans>City</Trans>;
export const STATE = <Trans>State</Trans>;
export const COUNTRY = <Trans>Country</Trans>;
export const AREA_OR_LOCALITY = <Trans>Area / Locality</Trans>;
export const CONFIRM_LOCATION = <Trans>Confirm location</Trans>;
export const UPDATE_THE_APP = <Trans>Update the app</Trans>;
export const LOCATION_NOT_AVAILABLE = <Trans>Location not available</Trans>;
export const TURN_ON_DEVICE_LOCATION = <Trans>Turn on device location</Trans>;
export const PLEASE_CHECK_BELOW_REASONS = (
  <Trans>Please check below reasons</Trans>
);
export const PICK_DELIVERY_LOCATION_FORM_MAP = (
  <Trans>Pick delivery location from map</Trans>
);
export const UPLOAD_YOUR_PICTURE = <Trans>Upload your picture</Trans>;
export const UPLOAD_YOUR_SHOP_PICTURE = <Trans>UPLOAD YOUR SHOP PICTURE</Trans>;
export const UPLOAD_YOUR_USER_PICTURE = <Trans>UPLOAD YOUR USER PICTURE</Trans>;
export const UPLOAD_YOUR_SHOP_PICTURE_ALIAS = {
  [PRODUCT_NAME.BIDCO]: UPLOAD_YOUR_SHOP_PICTURE,
  [PRODUCT_NAME.BUYGRO]: UPLOAD_YOUR_SHOP_PICTURE,
  [PRODUCT_NAME.DISTIMAN]: UPLOAD_YOUR_SHOP_PICTURE,
  [PRODUCT_NAME.STONESLANE]: UPLOAD_YOUR_SHOP_PICTURE,
  [PRODUCT_NAME.GENIEE]: UPLOAD_YOUR_SHOP_PICTURE,
  [PRODUCT_NAME.DIGITALSAATHI]: UPLOAD_YOUR_USER_PICTURE,
};
export const EMAIL = <Trans>Email</Trans>;
export const BY_CLICKING_PROCEED_YOU_AGREE_TO_OUR = (
  <Trans>By clicking 'Proceed', you agree to our</Trans>
);
export const TERMS_AND_CONDITIONS = <Trans>Terms and Conditions</Trans>;
export const ENTER_OTP = <Trans>Enter OTP</Trans>;
export const RESEND_OTP_IN = <Trans>Resend OTP in</Trans>;
export const RESENDING = <Trans>Resending</Trans>;
export const RESEND_OTP = <Trans>Resend OTP</Trans>;
export const HAVING_TROUBLE = <Trans>Having trouble?</Trans>;
export const CONTACT_SUPPORT = <Trans>Contact support</Trans>;
export const APP_RELATED_QUERIES = <Trans>App related queries</Trans>;
export const NOTIFICATIONS = <Trans>Notifications</Trans>;
export const LOAD_MORE = <Trans>Load more</Trans>;
export const LOADING = <Trans>Loading</Trans>;
export const UPDATE_YOUR_WHATSAPP_NUMBER = (
  <Trans>Update your whatsapp number</Trans>
);
export const UPDATE_YOUR_EMAIL_ADDRESS = (
  <Trans>Update your email address</Trans>
);
export const RESET_AND_TRY_ANOTHER_NUMBER = (
  <Trans>Reset & try another number</Trans>
);
export const OUTLET_FOUND_FILL_THE_FORM_AND_PROCEED = (
  <Trans>Outlet found, fill the form & Proceed</Trans>
);
export const NO_OUTLET_FOUND_TRY_ANOTHER_NUMBER = (
  <Trans>No outlet found, try another number</Trans>
);
export const REGISTER_YOUR_SHOP = <Trans>Register your shop</Trans>;
export const NEW_REGISTRATION = <Trans>New registration</Trans>;
export const REGISTER_YOUR_SHOP_ALIAS = {
  [PRODUCT_NAME.BIDCO]: REGISTER_YOUR_SHOP,
  [PRODUCT_NAME.BUYGRO]: REGISTER_YOUR_SHOP,
  [PRODUCT_NAME.DISTIMAN]: REGISTER_YOUR_SHOP,
  [PRODUCT_NAME.STONESLANE]: REGISTER_YOUR_SHOP,
  [PRODUCT_NAME.GENIEE]: REGISTER_YOUR_SHOP,
  [PRODUCT_NAME.DIGITALSAATHI]: NEW_REGISTRATION,
};
export const UPDATE_WORKING_HOURS = <Trans>Update working hours</Trans>;
export const I_DONT_HAVE_ANY_OTHER_MOBILE_NUMBER = (
  <Trans>I don't have any other mobile number</Trans>
);
export const ENTER_THE_6_DIGITS_OTP_SEND_TO_YOUR_MOBILE_NUMBER = (
  <Trans>Enter the 6 digits OTP sent to your mobile number</Trans>
);
export const SEEMS_THERE_IS_NO_OUTLET_PRESENT_WITH_THIS_NUMBER_DONT_WORRY_WE_ARE_HERE_FOR_YOU =
  (
    <Trans>
      Seems there is no outlet present with this number. Don't worry, we are
      here for you.
    </Trans>
  );
export const FIND_MY_OUTLET_HELPER_MESSAGE = (
  <Trans>
    If you want to be a part of an existing outlet, please enter the previous
    retailer number or if you have your outlet, please enter your other business
    number
  </Trans>
);
export const ORDER_NOW = <Trans>Order now</Trans>;
export const RATE_NOW = <Trans>Rate now</Trans>;
export const PENDING = <Trans>Pending</Trans>;
export const INACTIVE = <Trans>Inactive</Trans>;
export const REQUEST_NOW = <Trans>Request now</Trans>;
export const NO_BRANDS_HERE = <Trans>No brands here</Trans>;
export const ACTIVE_BRANDS = <Trans>Active brands</Trans>;
export const INACTIVE_BRANDS = <Trans>Inactive brands</Trans>;
export const APPROVAL_PENDING = <Trans>Approval pending</Trans>;
export const ADD_NEW_BRAND = <Trans>Add new brand</Trans>;
export const ADD_NEW_OUTLET = <Trans>Add new outlet</Trans>;
export const CHANGE_LANGUAGE = <Trans>Change language</Trans>;
export const SELECT_YOUR_LANGUAGE = <Trans>Select your language</Trans>;
export const REQUESTED_SUCCESSFULLY = <Trans>Requested successfully</Trans>;
export const FEEDBACK_SAVED_SUCCESSFULLY = (
  <Trans>Feedback saved successfully</Trans>
);
export const DEAL_REQUESTED = <Trans>Deal requested</Trans>;
export const UPDATE_MY_PROFILE = <Trans>Update My Profile</Trans>;
export const UPDATE_OUTLET_DETAILS = <Trans>Update Outlet Details</Trans>;
export const PROFILE_UPDATED_SUCCESSFULLY = (
  <Trans>Profile updated successfully</Trans>
);
export const OUTLET_ADDED_SUCCESSFULLY = (
  <Trans>Outlet added successfullly</Trans>
);
export const IT_WILL_BE_APPROVED_SOON = <Trans>It will be approved soon</Trans>;
export const MY_BRANDS = <Trans>My brands</Trans>;
export const OTHER_BRANDS = <Trans>Other Brands</Trans>;
export const MORE = <Trans>More</Trans>;
export const RETRY = <Trans>Retry</Trans>;
export const CLOSE = <Trans>Close</Trans>;
export const BRANDS = <Trans>Brands</Trans>;
export const CATEGORIES = <Trans>Categories</Trans>;
export const SUBMIT = <Trans>Submit</Trans>;
export const DISMISS = <Trans>Dismiss</Trans>;
export const CLAIM_NOW = <Trans>Claim now</Trans>;
export const CANCEL = <Trans>Cancel</Trans>;
export const ADD = <Trans>Add</Trans>;
export const FILTER = <Trans>Filter</Trans>;
export const FILTER_PRODUCTS = <Trans>Filter products</Trans>;
export const CLEAR = <Trans>Clear</Trans>;
export const APPLY = <Trans>Apply</Trans>;
export const OFFERS = <Trans>Offers</Trans>;
export const VIEW_MORE_OFFERS = <Trans>View more offers</Trans>;
export const OFF = <Trans>off</Trans>;
export const MARGIN = <Trans>margin</Trans>;
export const FREE = <Trans>Free</Trans>;
export const SELLER = <Trans>Seller</Trans>;
export const ORDER_CLOSE_WILL_OPEN_TOMORROW = (
  <Trans>Order closed, will open tomorrow</Trans>
);
export const ORDER_OPEN_TILL = (date: string) => (
  <Trans>Order open till {date}</Trans>
);
export const MY_ORDERS = <Trans>My Orders</Trans>;
export const PRICE = <Trans>Price</Trans>;
export const PRICE_PER_UNIT = <Trans>Price per unit</Trans>;
export const MRP = <Trans>MRP</Trans>;
export const UNITS = <Trans>Units</Trans>;
export const CASES = <Trans>Cases</Trans>;
export const TAP_TO_VIEW = <Trans>Tap to view</Trans>;
export const TAP_IMAGE_TO_VIEW_DETAILS = (
  <Trans>Tap image to view details</Trans>
);
export const TAKE_PHOTO = <Trans>Take photo</Trans>;
export const UPLOAD_PHOTO = <Trans>Upload photo</Trans>;
export const SUGGESTED_OUTLETS = <Trans>Suggested outlets</Trans>;
export const PLACE_ALL_ORDERS = <Trans>Place all orders</Trans>;
export const PLACING_ORDER = <Trans>Placing order</Trans>;
export const PREFERRED_DELIVERY_DATE = <Trans>Preferred delivery date</Trans>;
export const HIDE = <Trans>Hide</Trans>;
export const SHOW = <Trans>Show</Trans>;
export const HIDE_PRODUCTS = <Trans>Hide products</Trans>;
export const SHOW_PRODUCTS = <Trans>Show products</Trans>;
export const REMOVE_ITEMS = <Trans>Remove items</Trans>;
export const ORDER_BEFORE = <Trans>Order before</Trans>;
export const PRODUCT_NOT_AVAILABLE_NOW = (
  <Trans>Product not available now</Trans>
);
export const PRODUCTS = <Trans>Products</Trans>;
export const SEARCH_PRODUCTS = <Trans>Search products</Trans>;
export const RECENT_SEARCH = <Trans>Recent search</Trans>;
export const ORDER_ID = <Trans>Order ID</Trans>;
export const ORDER_DETAILS = <Trans>Order details</Trans>;
export const CANCEL_ORDER = <Trans>Cancel order</Trans>;
export const INVOICE = <Trans>Invoice</Trans>;
export const DELIVERED = <Trans>Delivered</Trans>;
export const NOT_DELIVERED = <Trans>Not delivered</Trans>;
export const MARKED_AS_RECEIVED = <Trans>Marked as received</Trans>;
export const MARKED_AS_NOT_RECEIVED = <Trans>Marked as not received</Trans>;
export const REORDER = <Trans>Reorder</Trans>;
export const CONFIRMATION = <Trans>Confirmation</Trans>;
export const ORDER_DISCLAIMER = <Trans>Order disclaimer</Trans>;
export const I_ACCEPT_ORDER_DISCLAMER = (
  <Trans>I accept order disclaimer</Trans>
);
export const REMOVE_ALL_AND_ADD = <Trans>Remove all & Add</Trans>;
export const ADD_TO_CART = <Trans>Add to cart</Trans>;
export const AMOUNT = <Trans>Amount</Trans>;
export const DELIVERY_CONFIRMATION = <Trans>Delivery Confirmation</Trans>;
export const NEXT = <Trans>Next</Trans>;
export const PREVIOUS = <Trans>Previous</Trans>;
export const VIEW_MORE_DETAILS = <Trans>View more details</Trans>;
export const CHANGE_BRAND = <Trans>Change brand</Trans>;
export const AVAILABLE_POINTS = <Trans>Available points</Trans>;
export const HISTORY = <Trans>History</Trans>;
export const DETAILS = <Trans>Details</Trans>;
export const POINTS_HISTORY = <Trans>Points History</Trans>;
export const FILTER_BY = <Trans>Filter by</Trans>;
export const ALL = <Trans>All</Trans>;
export const ON_THE_WAY = <Trans>On the way</Trans>;
export const EARNED = <Trans>Earned</Trans>;
export const HOLD = <Trans>Hold</Trans>;
export const REDEEMED = <Trans>Redeemed</Trans>;
export const ROLLBACK = <Trans>Rollback</Trans>;
export const EXPIRED = <Trans>Expired</Trans>;
export const VALID_TILL = <Trans>valid till</Trans>;
export const CURRENT_DEALS = <Trans>Current deals</Trans>;
export const REDEEMED_DEALS = <Trans>Redeemed deals</Trans>;
export const TOTAL_POINTS = <Trans>Total points</Trans>;
export const REQUIRED_POINTS = <Trans>Required points</Trans>;
export const APPROVED = <Trans>Approved</Trans>;
export const REJECTED = <Trans>Rejected</Trans>;
export const PENDING_APPROVAL = <Trans>Pending approval</Trans>;
export const VERY_BAD = <Trans>Very Bad</Trans>;
export const BAD = <Trans>Bad</Trans>;
export const AVERAGE = <Trans>Average</Trans>;
export const GOOD = <Trans>Good</Trans>;
export const AWASOME = <Trans>Awesome</Trans>;
export const RATE_AND_REVIEW = <Trans>Rate & Review</Trans>;
export const MY_SHOP = <Trans>My shop</Trans>;
export const SHARE_WITH_RETAILER = <Trans>Share with retailer</Trans>;
export const PLACED_BY_SALESMAN = <Trans>Placed by salesman</Trans>;
export const PLACED_FROM_APP = <Trans>Placed from app</Trans>;
export const FEEDBACK_LABELS = {
  '1': VERY_BAD,
  '2': BAD,
  '3': AVERAGE,
  '4': GOOD,
  '5': AWASOME,
};
export const RATE_US_ON = <Trans>Rate us on</Trans>;
export const ORDER_EXPERIENCE = <Trans>Order Experience</Trans>;
export const PRODUCT_EXPERIENCE = <Trans>Product Experience</Trans>;
export const HOW_WAS_YOUR_EXPERIENCE = <Trans>How was your experience?</Trans>;
export const YOUR_REVIEW = <Trans>Your review</Trans>;
export const PLEASE_ROTATE_YOUR_DEVICE = (
  <Trans>Please rotate your device</Trans>
);
export const WE_DONT_SUPPORT_LANDSCAPE_MORE_YET_PLEASE_GO_BACK_TO_PORTRAIT_MODE_FOR_THE_BEST_EXPERIENCE =
  (
    <Trans>
      We don't support landscape mode yet. Please go back to portrait mode for
      the best experience.
    </Trans>
  );
export const ORDER_AGREEMENT_MESSAGE = (
  <Trans>
    This app is only a Platform for communication. We do not determine, advice,
    have any control, or guarantee in any way the offering or acceptance of any
    commercial/contractual terms from Brands and the Distributors. The prices
    mentioned are indicative. Full payment to be made against the delivery of
    stock.
  </Trans>
);
export const SAME_AS_MY_PHONE_NUMBER = <Trans>Same as my mobile number</Trans>;
export const WHATSAPP_HELP_MESSAGE = (
  <Trans>
    Enroll your WhatsApp number to get updated with the exciting offers and
    other important information
  </Trans>
);
export const NUMBER_POINTS = (number: number) => <Trans>{number} points</Trans>;
export const STARTS_FROM_DATE = (date: string) => (
  <Trans>Starts from {date}</Trans>
);
export const CURRENTLY_NO_BRANDS_ASSOCIATED_WITH_YOUR_OUTLET_PLEASE_VISIT_OTHER_BRANDS_TAB =
  (
    <Trans>
      Currently there are no brands associated with your Outlet. Please visit
      'Other Brands' tab
    </Trans>
  );
export const CURRENTLY_NO_BRANSD_IN_YOUR_AREA_WE_WILL_BE_ADDING_MORE_BRANDS_SOON =
  (
    <Trans>
      Currently there are no brands present in your area. We will be adding more
      brands soon
    </Trans>
  );
export const RATE_ON_GOOGLE_PLAY_MESSAGE = (appName) => (
  <Trans>
    If you like {appName}, we would appreciate it if you could rate the app on
    Google Play Store also. Thanks!
  </Trans>
);
export const EXPIRED_ON_DATE = (date: string) => (
  <Trans>Expired on {date}</Trans>
);
export const EXPIRES_ON_DATE = (date: string) => (
  <Trans>Expires on {date}</Trans>
);
export const EARN_NUMBER_POINTS_MORE_TO_CLAIM = (number: number | string) => (
  <Trans>Earn {number} points more to claim</Trans>
);

export const YOU_WILL_SAVE_NUMBER_ON_THE_ORDER_FROM_MRP = (str: string) => (
  <Trans>You will save {str} on this order from MRP</Trans>
);
export const YOUR_DELIVERY_ADDRESS = (number: number) => (
  <Plural
    value={number}
    one={'Your delivery address'}
    other={'Your delivery addresses'}
  />
);
export const UNIT_PER_CASE_WITH_PLURAL = (number: number) => (
  <Plural value={number} one={'# unit per case'} other={'# units per case'} />
);
export const MORE_SELLER_WITH_PLURAL = (number: number) => (
  <Plural value={number} one={'# more seller'} other={'# more sellers'} />
);
export const NO_ITEM_WITH_PLURAL = (number: number) => (
  <Plural value={number} _0={'No Item'} one={'# Item'} other={'# Items'} />
);
export const YOU_CANT_ORDER_NUMBER_PRODUCT_NOW_WITH_PLURAL = (
  number: number
) => (
  <Plural
    value={number}
    one={"You can't order # product now"}
    other={"You can't order # products now"}
  />
);
export const INVOICE_DETAILS_WITH_PLURAL = (number: number) => (
  <Plural
    value={Number(number)}
    _0={'No invoice details'}
    one={'# invoice details'}
    other={'# invoice details'}
  />
);
export const YOU_CART_ALREADY_HAS_NUMBER_PRODUCT_WITH_PLURAL = (
  number: number
) => (
  <Plural
    value={number}
    one={'Your cart already has # product'}
    other={'Your cart already has # products'}
  />
);

export const PAYMENTS = <Trans>Payments</Trans>;
export const PAY_NOW = <Trans>Pay now</Trans>;
export const PENDING_BALANCE = <Trans>Pending balance</Trans>;
export const EDIT_PAYMENT = <Trans>Edit payment</Trans>;
export const TRANSACTION_DONE = <Trans>Transaction done</Trans>;
export const SETTLE_NOW = <Trans>Settle now</Trans>;
export const NO_INVOICES_AVAILABLE = <Trans>No invoices available</Trans>;
export const NO_PENDING_INVOICES = <Trans>No pending invoices</Trans>;
export const AMOUNT_TO_BE_PAID = <Trans>Amount to be paid</Trans>;
export const PAYMENT_MARKED_SUCCESSFULLY = (
  <Trans>Payment marked successfully</Trans>
);
export const WANT_TO_MAKE_PARTIAL_PAYMENT = (
  <Trans>Want to make the partial payment?</Trans>
);
export const CONFIRM = <Trans>Confirm</Trans>;
export const DISTRIBUTORS = <Trans>Distributors</Trans>;

export const CUSTOMER_CARE = <Trans>Customer care</Trans>;

export const CANCEL_ORDER_CONFIRMATION = (
  <Trans>Cancel order confirmation</Trans>
);

export const REASON_FOR_CANCELLING = <Trans>Reason for cancelling</Trans>;
export const ANY_OTHER_COMMENTS = <Trans>Any other comments</Trans>;
export const ORDER_CANCELLED_SUCCESSFULLY = (
  <Trans>Order cancelled successfully</Trans>
);

export const YOU_SAVE = (amountWithCurrency: string) => (
  <Trans>You save {amountWithCurrency}</Trans>
);

export const YOU_GET_FREE_SKU_WITH_PLURAL = (quantity: number) => (
  <Plural
    value={quantity}
    one={'You get # free sku'}
    other={'You get # free skus'}
  />
);

export const REMOVE_FROM_CART_CONFIRMATION = <Trans>Remove from cart?</Trans>;
export const VIEW = <Trans>View</Trans>;
export const NEW = <Trans>New</Trans>;
export const SEEN = <Trans>Seen</Trans>;

export const ACCEPTANCE = <Trans>Acceptance</Trans>;
export const FULFILLMENT = <Trans>Fulfillment</Trans>;
export const PLACEMENT = <Trans>Placement</Trans>;
export const CANCELLED = <Trans>Cancelled</Trans>;

export const ORDER_STAGE_LABELS = {
  PLACED: PLACEMENT,
  ACCEPTED: ACCEPTANCE,
  FULFILLMENT: FULFILLMENT,
  DELIVERY: DELIVERED,
  REJECT: CANCELLED,
};

export const RETURNS = <Trans>Returns</Trans>;
export const QUANTITY = <Trans>Quantity</Trans>;
export const SHOPPING_CART = <Trans>Shopping cart</Trans>;
export const RETURN_DETAILS = <Trans>Return details</Trans>;
export const PRODUCTS_TO_RETURN = <Trans>Products to return</Trans>;
export const PLACE_PRODUCT_RETURN_REQUEST = (
  <Trans>Place product return request</Trans>
);
export const ADD_PRODUCTS_THAT_YOU_WANT_TO_RETURN_AND_RAISE_REQUEST = (
  <Trans>Add products that you want to return and raise request</Trans>
);
export const VIEW_YOUR_PREVIOUS_RETURNS = (
  <Trans>View your previous returns</Trans>
);
export const OR = <Trans>Or</Trans>;
export const CONTINUE_BUYING = <Trans>Continue buying</Trans>;
export const PRODUCT_RETURN_SUCCESSFUL = (
  <Trans>Product return successful</Trans>
);
export const RETURN_ID = <Trans>Return ID</Trans>;
export const TRACK_RETURN_STATUS = <Trans>Track return status</Trans>;
export const CONTINUE = <Trans>Continue</Trans>;
export const CONFIRM_RETURN = <Trans>Confirm return</Trans>;
export const WHY_ARE_YOU_RETURNING_THIS = (
  <Trans>Why are you returning this?</Trans>
);
export const VIEW_UPLOADED_IMAGE = <Trans>View uploaded image</Trans>;
export const REASON = <Trans>Reason</Trans>;
export const ADD_MORE_PRODUCTS = <Trans>Add more products</Trans>;
export const CONFIRMED = <Trans>Confirmed</Trans>;
export const REQUESTED = <Trans>Requested</Trans>;
export const PARTIALLY_REPLACED = <Trans>Partially replaced</Trans>;
export const REPLACED = <Trans>Replaced</Trans>;
export const RETURNED = <Trans>Returned</Trans>;
export const PRODUCT_RETURN_STATUS_LABELS = {
  APPROVED: APPROVED,
  CONFIRMED: CONFIRMED,
  PARTIALREPLACED: PARTIALLY_REPLACED,
  PENDING: PENDING,
  REJECTED: REJECTED,
  REQUESTED: REQUESTED,
  REPLACED: REPLACED,
  REJECT: CANCELLED,
  RETURNED: RETURNED,
};
export const SHOP_BY_BRANDS = <Trans>Shop by brands</Trans>;
export const SHOP_BY_CATEGORIES = <Trans>Shop by categories</Trans>;
export const YOU_WILL_GET_NOTIFITION_ON_FURTHER_ACTION_ON_YOUR_REQUEST = (
  <Trans>You will get a notification on further action on your request.</Trans>
);
export const TOTAL_POINTS_AVAILABLE = <Trans>Total points available</Trans>;
export const TOTAL_CASHBACK_AVAILABLE = <Trans>Total cashback available</Trans>;
export const CASHBACK_WON_TILL_NOW_NUMBER = (str: string | number) => (
  <Trans>Cashback won till now {str}</Trans>
);
export const POINTS_WON_TILL_NOW_NUMBER = (str: string | number) => (
  <Trans>Points won till now {str}</Trans>
);
export const POINTS = <Trans>Points</Trans>;
export const CASHBACK = <Trans>Cashback</Trans>;
export const ON_HOLD_FOR_REDEMPTION = <Trans>On hold for redemption</Trans>;
export const YOU_HAVE_WON = <Trans>You have won</Trans>;
export const USED = <Trans>Used</Trans>;
export const REVERSED = <Trans>Reversed</Trans>;
export const YOU_HAVE_RETURNED = <Trans>You have returned</Trans>;
export const REWARDS_LEDGER_LABELS = {
  BLOCKED: ON_HOLD_FOR_REDEMPTION,
  EARNED: YOU_HAVE_WON,
  EXPIRED: EXPIRED,
  PARKED: ON_THE_WAY,
  REDEEMED: USED,
  ROLLBACK: REVERSED,
  REVERSED: YOU_HAVE_RETURNED,
};
export const REDEMPTIONS_LABELS = {
  APPROVED: APPROVED,
  PENDING: PENDING_APPROVAL,
  REJECTED: REJECTED,
};
export const NUMBER_OFFER_APPLIED_PLURAL = (number: number) => (
  <Plural
    value={number}
    _0={'No offer applied'}
    one={'# offer applied'}
    other={'# offers applied'}
  />
);
export const NUMBER_CASHBACK_PLURAL = (number: number) => (
  <Plural
    value={number}
    _0={'No cashback'}
    one={'# cashback'}
    other={'# cashbacks'}
  />
);
export const CASHBACK_APPLIED = <Trans>Cashback applied</Trans>;
export const SAVE_MORE_WITH_CASHBACK = <Trans>Save more with cashback</Trans>;
export const AMOUNT_WILL_BE_ADJUSTED_IN_YOUR_INVOICE = (
  <Trans>Amount will be adjusted in your invoice</Trans>
);
export const AVAIL_AMOUNT_CASHBACK_ON_TOTAL_AMOUNT = (str: string | number) => (
  <Trans>Avail {str} cashback on total amount</Trans>
);
export const AMOUNT_CASHBACK_APPLIED = (str: string | number) => (
  <Trans>{str} cashback applied</Trans>
);
export const PLEASE_FILL_THE_CARD_DETAILS = (
  <Trans>Please fill the card details</Trans>
);
export const PLEASE_DO_NOT_REFRESH_THIS_PAGE = (
  <Trans>Please do not refresh this page</Trans>
);
export const PAYMENT_SUCCESFUL = <Trans>Payment successful</Trans>;
export const PAYMENT_FAILURE = <Trans>Payment failure</Trans>;
export const PAYMENT_REVERTED = <Trans>Payment reverted</Trans>;
export const PAYMENT_AWAITED = <Trans>Payment awaited</Trans>;
export const PENDING_INVOICES = <Trans>Pending invoices</Trans>;
export const ALL_INVOICES = <Trans>All invoices</Trans>;
export const LICENCE_NUMBER = <Trans>Licence number</Trans>;
export const TRADE_LICENCE_NUMBER = <Trans>Trade license number</Trans>;
export const LICENCE_NUMBER_ALIAS = {
  [PRODUCT_NAME.BIDCO]: LICENCE_NUMBER,
  [PRODUCT_NAME.BUYGRO]: TRADE_LICENCE_NUMBER,
  [PRODUCT_NAME.DISTIMAN]: LICENCE_NUMBER,
  [PRODUCT_NAME.STONESLANE]: LICENCE_NUMBER,
  [PRODUCT_NAME.GENIEE]: LICENCE_NUMBER,
  [PRODUCT_NAME.DIGITALSAATHI]: LICENCE_NUMBER,
};
export const NUMBER_ALREADY_EXISTS = <Trans>Number already exists</Trans>;
export const TOTAL_PRICE = <Trans>Total price</Trans>;
export const WELCOME_TO_APP_NAME = (str: string) => (
  <Trans>Welcome to {str}</Trans>
);
export const WE_HAVE_SUCCESSFULLY_REGISTERED_YOUR_DETAILS_AND_IT_WILL_BE_REVIEWED_SOON_BY_OUR_TEAM =
  (
    <Trans>
      We have successfully registered your details and it will be reviewed soon
      by our team
    </Trans>
  );
export const GREETINGS_WE_HAVE_APPROVED_YOUR_DETAILS_HAPPY_SHOPPING = (
  <Trans>Greetings! We have approved your details, Happy shopping!</Trans>
);
export const SHOP_NOW = <Trans>Shop now</Trans>;
export const CHECK_NOW = <Trans>Check now</Trans>;
export const UPLOAD_IMAGES = <Trans>Upload images</Trans>;
export const ADD_PRODUCT = <Trans>Add product</Trans>;
export const TRACK_TRANSACTIONS = <Trans>Track transactions</Trans>;
export const TRANSACTION_ID = <Trans>Transaction ID</Trans>;
export const VIA_SALESMAN = <Trans>Via salesman</Trans>;
export const VIA_APP = <Trans>Via app</Trans>;
export const PAID_VIA = <Trans>Paid via</Trans>;
export const NO_RECORDS = <Trans>No records</Trans>;
export const NO_COLLECTIONS_HISTORY = <Trans>No collections history</Trans>;
export const SHOW_ALL = <Trans>Show all</Trans>;
export const NO_IMAGE = <Trans>No image</Trans>;
export const YOUR_LAST_ORDER = <Trans>Your last order</Trans>;
export const RECENT_PURCHASES = <Trans>Recent purchases</Trans>;
export const SHOP_BY_COMPANIES = <Trans>Shop by companies</Trans>;
export const ASSOCIATE_WITH_COMPANY = <Trans>Associate with company</Trans>;
export const NUMBER_OFFERS = (number: number) => (
  <Plural value={number} _0={'No offer'} one={'# offer'} other={'# offers'} />
);
export const CHANGE_SELLER = <Trans>Change seller</Trans>;
export const RRP = <Trans>RRP</Trans>;
export const MRP_ALIAS = {
  [PRODUCT_NAME.BIDCO]: RRP,
  [PRODUCT_NAME.BUYGRO]: MRP,
  [PRODUCT_NAME.DISTIMAN]: MRP,
  [PRODUCT_NAME.STONESLANE]: MRP,
  [PRODUCT_NAME.GENIEE]: MRP,
  [PRODUCT_NAME.DIGITALSAATHI]: MRP,
};
export const COUNTY = <Trans>County</Trans>;
export const CARTONS = <Trans>Cartons</Trans>;
export const PIECES = <Trans>Pieces</Trans>;
export const CASES_ALIAS = {
  [PRODUCT_NAME.BIDCO]: CARTONS,
  [PRODUCT_NAME.BUYGRO]: CASES,
  [PRODUCT_NAME.DISTIMAN]: CASES,
  [PRODUCT_NAME.STONESLANE]: CASES,
  [PRODUCT_NAME.GENIEE]: CASES,
  [PRODUCT_NAME.DIGITALSAATHI]: CASES,
};
export const UNITS_ALIAS = {
  [PRODUCT_NAME.BIDCO]: PIECES,
  [PRODUCT_NAME.BUYGRO]: UNITS,
  [PRODUCT_NAME.DISTIMAN]: UNITS,
  [PRODUCT_NAME.STONESLANE]: UNITS,
  [PRODUCT_NAME.GENIEE]: UNITS,
  [PRODUCT_NAME.DIGITALSAATHI]: UNITS,
};
export const FAVOURITE_PRODUCTS = <Trans>Favourite Products</Trans>;
export const MARKED_AS_FAVOURITE = <Trans>Marked as favourite</Trans>;
export const UNMARKED_FROM_PRODUCTS = <Trans>Unmarked from favourite</Trans>;
export const COMMINICATION_PREFERENCES = (
  <Trans>Communication Preferences</Trans>
);
export const SUCCESSFULLY_UPDATED_COMMUNICATION_RESPONSE = (
  <Trans>Successfully updated communication response</Trans>
);
export const CHECK_USER_PROFILE_TO_CHANGE_PREFERENCE = (
  <Trans>Check user profile page to change preference</Trans>
);
export const COMMUNICATION_CONSENT_MESSAGE = (
  <Trans>
    In case you opt-out of these communication preferences, you will stop
    receving updates on new product and attractive offers for greater savings.
    For complete Terms and Conditions click below
  </Trans>
);
export const SELECT_COMPANIES_TO_SEE_DETAILS = (
  <Trans> Select companies to see details</Trans>
);
export const ORDER_AND_TRANSACTION = <Trans> Order & Transaction</Trans>;
export const CHECK_OUT_YOUR_LAST_ORDERS_AND_TRANSACTIONS_BRAND_WISE = (
  <Trans> Check out your last orders and transactions brand wise </Trans>
);
export const GO_BACK_TO_HOME_PAGE = <Trans>Go back to Home page</Trans>;
export const ASSOCIATED_EMPLOYEES = <Trans>Associated employees</Trans>;
export const UNKNOWN_ADDRESS = <Trans>Unknown address</Trans>;
export const TRACK_ORDER = <Trans>Track order</Trans>;
export const ORDER_STATUS_DETAILS = <Trans>Order status details</Trans>;
export const ASSOCIATE_WITH_BELOW_OUTLETS = (number: number) => (
  <Plural
    value={number}
    _0={'No outlet'}
    one={'Associate with below outlet'}
    other={'Associate with below outlets'}
  />
);
export const REQUEST_WILL_EXPIRE_IN_TIME_MINS = (time: string) => (
  <Trans>Request will expire in {time} mins</Trans>
);
export const INCLUDING_TAX = <Trans>Including tax</Trans>;
export const ENTER_MANUALLY = <Trans>Enter manually</Trans>;
export const LOOKING_FOR_VERIFICATION_CODE = (
  <Trans>Looking for verification code</Trans>
);
export const ADMIN = <Trans>Admin</Trans>;
export const MEMBER = <Trans>Member</Trans>;
export const MAKE_ADMIN = <Trans>Make admin</Trans>;
export const MAKE_MEMBER = <Trans>Make member</Trans>;
export const EMPLOYEE_NAME = <Trans>Employee name</Trans>;
export const EMPLOYEE_ADDED_SUCCESSFULLY = (
  <Trans>Employee added successfullly</Trans>
);
export const YOU = <Trans>You</Trans>;
export const EMPLOYEE_UPDATED_SUCCESSFULLY = (
  <Trans>Employee updated successfully</Trans>
);
export const EMPLOYEE_REMOVED_SUCCESSFULLY = (
  <Trans>Employee removed successfully</Trans>
);
export const UPDATE_ROLE_CONFIRMATION = <Trans>Update role confirmation</Trans>;
export const REMOVE_USER_CONFIRMATION = <Trans>Remove user confirmation</Trans>;
export const DISCLAIMER = <Trans>Disclaimer: </Trans>;
export const UPDATING_THIS_USER_AS_ADMIN_FOR_THIS_OUTLET = (
  <Trans>Updating this user's role as Admin for this outlet.</Trans>
);
export const UPDATING_THIS_USER_AS_MEMBER_FOR_THIS_OUTLET = (
  <Trans>Updating this user's role as Member for this outlet.</Trans>
);
export const SELF_REMOVAL_DISCLAIMER_MESSAGE = (
  <Trans>
    You will not be able to access this outlet going forward and app will be
    reloaded after this action!
  </Trans>
);
export const OTHER_USER_REMOVAL_DISCLAIMER_MESSAGE = (
  <Trans>
    This user will not be able to access this outlet after this action!
  </Trans>
);
export const ARE_YOU_SURE_OF_TAKING_THIS_ACTION = (
  <Trans>Are you sure of taking this action?</Trans>
);

export const REPORTS = <Trans>Reports</Trans>;
